import { ISearchPromosResponse } from '../repositories/newbuilding-promos/v1/search-promos';
import { ISeoData } from '../types/seoData';

export const mapSeoData = (promosResponse: ISearchPromosResponse): ISeoData => {
  const seoData = promosResponse.seoData;

  return {
    description: seoData.description || '',
    title: seoData.title || '',
    h1: seoData.h1 || '',
    pageDescription: seoData.pageDescription || '',
  };
};
